/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LDAPServerUser
 */
export interface LDAPServerUser {
    /**
     * 
     * @type {string}
     * @memberof LDAPServerUser
     */
    dn: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerUser
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerUser
     */
    mail: string;
}

export function LDAPServerUserFromJSON(json: any): LDAPServerUser {
    return LDAPServerUserFromJSONTyped(json, false);
}

export function LDAPServerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServerUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dn': json['dn'],
        'name': json['name'],
        'username': json['username'],
        'mail': json['mail'],
    };
}

export function LDAPServerUserToJSON(value?: LDAPServerUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dn': value.dn,
        'name': value.name,
        'username': value.username,
        'mail': value.mail,
    };
}


